import { createHistory } from '@reach/router';

export const history = createHistory(window);
export const { navigate } = history;
